module.exports = __webpack_public_path__ + "img/第一層標題icon.9c12fecd.svg";